import { createRouter, createWebHistory } from 'vue-router';

/** @Home */
import Home from '@/views/Home.vue';
/** @Pages */
import Policy from '@/views/Pages/Policy.vue';
import TransactionLaw from '@/views/Pages/TransactionLaw.vue';
import Survey from '@/views/Pages/Survey.vue';
import Terms from '@/views/Pages/Terms.vue';
import MldTerms from '@/views/Pages/MldTerms.vue';
import MldPolicy from '@/views/Pages/MldPolicy.vue';
import NotFound from '@/views/Pages/NotFound.vue';
import LoginApprove from '@/views/Pages/LoginApprove.vue';
import ShortUrlRedirect from '@/views/Pages/ShortUrlRedirect.vue';


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      name: 'Home',
      label: 'ホーム',
    },
  },
  {
    path: '/pages/privacy-policy',
    name: 'Policy',
    component: Policy,
    meta: {
      name: 'Policy',
      label: 'プライバシーポリシー',
    },
  },
  {
    path: '/pages/transactionLaw/',
    name: 'transaction-law',
    component: TransactionLaw,
    meta: {
      name: 'TransactionLaw',
      label: '特定商取引法に基づく表記',
    },
  },
  {
    path: '/survey',
    name: 'Survey',
    component: Survey,
    meta: {
      name: 'Survey',
      label: '配車需要調査',
    },
  },
  {
    path: '/pages/terms/',
    name: 'Terms',
    component: Terms,
    meta: {
      name: 'Terms',
      label: '利用規約',
    },
  },
  {
    path: '/pages/mld-privacy-policy/',
    name: 'MldPolicy',
    component: MldPolicy,
    meta: {
      name: 'MldPolicy',
      label: 'MITT LINE DRIVER プライバシーポリシー',
    },
  },
  {
    path: '/pages/mld-terms/',
    name: 'MldTerms',
    component: MldTerms,
    meta: {
      name: 'MldTerms',
      label: 'MITT LINE DRIVER 利用規約',
    },
  },
  {
    // ログインのメール承認（2段階認証 #3917）。承認メールのURLから開く
    path: '/login/approve',
    name: 'LoginApprove',
    component: LoginApprove,
    meta: {
      name: 'LoginApprove',
      label: 'ログインの承認',
    },
  },
  {
    // SMS の短縮URL（#4031。mitt.app をお名前のサーバーへ移すため ptr から移した）
    path: '/s/:code',
    name: 'ShortUrlRedirect',
    component: ShortUrlRedirect,
    meta: {
      name: 'ShortUrlRedirect',
      label: 'リダイレクト',
      // リダイレクトするだけの画面なので、ヘッダー・フッターを出さない
      hideLayout: true,
    },
  },
  // 未定義のパスは404を表示する。キャッチオールのため必ず末尾に置く
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      name: 'NotFound',
      label: 'ページが見つかりません',
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // ページ遷移時
  scrollBehavior(to, from, savedPosition) {
    let position = {};
    // fromとtoの違いがない場合はスルー
    if (from.path && to.path === from.path) return;
    if (!to.hash) {
      // ハッシュがなく、
      if (savedPosition) { // ブラウザバック
        position = { top: savedPosition.top };
      } else { // ページ遷移
        position = { top: 0 };
      }
    } else {
      // ハッシュが存在する場合スクロール
      position = { selector: to.hash };
    }
    return position;
  },
});

export default router;
